import { Layout } from "pages/ui/layout/layout";

import { DepositSection } from "./ui/deposit-section/section";
import { FAQSection } from "./ui/faq-section/faq-section";
import { Hero } from "./ui/hero";
import { PoolsSection } from "./ui/pools-section/section";

export const PreDeposit = () => {
  return (
    <Layout>
      <Hero className="mt-24" />
      <DepositSection />
      <PoolsSection />
      <FAQSection />
    </Layout>
  );
};
